import { render, staticRenderFns } from "./DelServiceBusiness.vue?vue&type=template&id=73ca1016&scoped=true"
import script from "./DelServiceBusiness.vue?vue&type=script&lang=js"
export * from "./DelServiceBusiness.vue?vue&type=script&lang=js"
import style0 from "./DelServiceBusiness.vue?vue&type=style&index=0&id=73ca1016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ca1016",
  null
  
)

export default component.exports